export default "__VITE_ASSET__VAm5mFTdOsV9Ev4k13$oxg__"